/**
 * Class representing the operation status returned by the API
 */
export class OperationStatus {
  isSuccess: boolean = false;
  message: string = '';
  userNote?: string;
  errorDetails?: string;
  statusCode: string = '';
}
